import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from 'oidc-react';
import reportWebVitals from './reportWebVitals';
import App from './App';
import AppDashboardLayout from './components/dashboard';
import PageSelectorPageContent from './pages/page-selector-page-content';
import CertificateBasicPageContent from './pages/certificate-basic-page-content';
import CertificatePremiumPageContent from './pages/certificate-premium-page-content';
import PersonalFlyerPageContent from './pages/personal-flyer-page-content';
import ArtistSlidePageContent from './pages/artist-slide-page-content';
import UtilityProofPageContent from './pages/utility-proof-page-content';
import DocumentationVideoDisplayPageContent from './pages/documentation-video-display-page-content';
import DocumentationDataMergePageContent from './pages/documentation-data-merge-page-content';
import MasterfulMindsPageContent from './pages/masterful-minds-page-content';
import Constants from './config/constants';
import './index.css';

const FUTURE_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
  v7_normalizeFormMethod: true,
  v7_fetcherPersist: true,
  v7_partialHydration: true,
  v7_skipActionErrorRevalidation: true
};

const OIDC_CONFIG = {
  onSignIn: () => {

  },
  authority: Constants.OIDC_AUTHORITY,
  clientId: Constants.OIDC_CLIENT_ID,
  redirectUri: Constants.OIDC_REDIRECT_URL
};

const router = createBrowserRouter([
  {
    Component: App, // root layout route
    children: [
      {
        path: '/',
        Component: AppDashboardLayout,
        children: [
          {
            path: '',
            Component: PageSelectorPageContent,
          },
          {
            path: 'certificates',
            children: [
              {
                path: 'simple',
                Component: CertificateBasicPageContent,
              },
              {
                path: 'divine',
                Component: CertificatePremiumPageContent,
              },
            ]
          },
          {
            path: 'page-maker',
            children: [
              {
                path: 'flyer',
                Component: PersonalFlyerPageContent,
              },
              {
                path: 'slide',
                Component: ArtistSlidePageContent,
              },
              {
                path: 'masterful',
                Component: MasterfulMindsPageContent,
              },
            ],
          },
          {
            path: 'utilities',
            children: [
              {
                path: 'proof',
                Component: UtilityProofPageContent,
              },
            ],
          },
          {
            path: 'documentation',
            children: [
              {
                path: 'video-display',
                Component: DocumentationVideoDisplayPageContent,
              },
              {
                path: 'data-merge',
                Component: DocumentationDataMergePageContent,
              },
            ],
          },
        ],
      },
    ],
  },
], { future: FUTURE_FLAGS });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider {...OIDC_CONFIG} >
      <RouterProvider router={router} future={FUTURE_FLAGS} />
    </AuthProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
